import styled from 'styled-components'

export const ItemWrapper = styled.div`
  width: 226px;
`
